import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var Skill = /*#__PURE__*/function (_Entity) {
  _inherits(Skill, _Entity);

  var _super = _createSuper(Skill);

  function Skill() {
    _classCallCheck(this, Skill);

    return _super.apply(this, arguments);
  }

  _createClass(Skill, [{
    key: "name",
    get: function get() {
      return this.props.name;
    }
  }, {
    key: "instructions",
    get: function get() {
      return this.props.instructions;
    }
  }, {
    key: "actions",
    get: function get() {
      return this.props.actions;
    }
  }, {
    key: "outputStructure",
    get: function get() {
      return this.props.outputStructure;
    }
  }, {
    key: "llmProviderId",
    get: function get() {
      return this.props.llmProviderId;
    }
  }, {
    key: "modelId",
    get: function get() {
      return this.props.modelId;
    }
  }, {
    key: "required",
    get: function get() {
      return this.props.required;
    }
  }, {
    key: "additionalProperties",
    get: function get() {
      return this.props.additionalProperties;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.name,
        argumentName: 'Name'
      }, {
        argument: props.instructions,
        argumentName: 'Instructions'
      }, {
        argument: props.actions,
        argumentName: 'Actions'
      }, {
        argument: props.outputStructure,
        argumentName: 'OutputStructure'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid skill props');
      }

      if (typeof props.actions !== 'object' || props.actions === null) {
        return Result.fail('Actions must be an object');
      }

      var skill = new Skill(props, new UniqueEntityID(props.id));
      return Result.ok(skill);
    }
  }]);

  return Skill;
}(Entity);